// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plus-minus[data-v-4f79d939]{min-width:70px;display:flex;align-items:center}.plus-minus button[data-v-4f79d939]:hover{background-color:var(--accent-btn)}.plus-minus .value[data-v-4f79d939]{min-width:25px;max-width:30px;display:flex;align-items:center;justify-content:center}.label[data-v-4f79d939]{padding-right:1em}", ""]);
// Exports
module.exports = exports;
